module.exports = __webpack_public_path__ + "static/img/preview-nine.d4100a7d.png";